import React from 'react';
import {
  Dialog,
  DialogContent,
  Grid,
  Box,
  Typography,
  Button,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const NonRefundableDialog = ({ open, onClose, onAccept }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <Grid container>
          {/* Icono de advertencia */}
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <WarningIcon
              sx={{
                position: 'relative',
                color: '#F8D000',
                width: { xs: '50px', sm: '90px' },
                height: { xs: '50px', sm: '90px' },
              }}
            />
          </Grid>

          {/* Título y descripción */}
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Box>
              <Typography
                sx={{
                  color: '#000',
                  fontWeight: 600,
                  fontSize: { xs: '16px', sm: '20px' },
                }}
              >
                Reserva No reembolsable
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{ color: '#000', fontSize: { xs: '14px', sm: '16px' } }}
              >
                La reserva que usted va a realizar no es reembolsable. Una vez
                realizada correrá con los gastos de cancelación propios del
                establecimiento seleccionado.
              </Typography>
            </Box>
          </Grid>

          {/* Botones */}
          <Grid item xs={12} sx={{ mt: 2, mb: 2, width: '100%' }}>
            <Grid container justifyContent="space-between" spacing={2}>
              <Grid item xs={5}>
                <Button
                  onClick={onClose}
                  sx={{
                    width: '100%',
                    color: '#FFFFFF',
                    bgcolor: '#FF2020',
                    fontSize: { xs: '12px', sm: '14px' },
                    '&:hover': { bgcolor: '#e61b1b' },
                  }}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item xs={5}>
                <Button
                  onClick={onAccept}
                  sx={{
                    width: '100%',
                    color: '#FFFFFF',
                    bgcolor: '#03C868',
                    fontSize: { xs: '12px', sm: '14px' },
                    '&:hover': { bgcolor: '#02b359' },
                  }}
                >
                  Aceptar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default NonRefundableDialog;
